'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11463/lib/node_modules/landr/theme/node_modules/property-information/normalize.js
// module id = 894
// module chunks = 0